import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';

import { LayoutComponent } from './layout/layout.component';
import { IonicModule } from '@ionic/angular';
import { QbHomeItaComponentsLibModule } from '@fwmovilidad/qb-home-ita-components-lib';
import { GenesysChatComponent } from './components/genesys-chat/genesys-chat.component';

const COMPONENTS = [LayoutComponent, GenesysChatComponent];

const MODULES = [
  CommonModule,
  RouterModule,
  IonicModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  QbHomeItaComponentsLibModule,
];

const DIRECTIVES = [];

@NgModule({
  imports: [...MODULES],
  declarations: [...COMPONENTS, ...DIRECTIVES],
  exports: [...COMPONENTS, ...DIRECTIVES, ...MODULES],
  providers: [TranslatePipe],
})
export class SharedModule {}
